import { apiSlice } from '../Slices/apiSlice';

export const currencyService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllCurrencies: builder.query({
            query: () => "/currency-management/managed-currency",
            providesTags: ['currency']
        }),

        getCurrencyById: builder.query({
            query: (currencyId) => `/currency-management/managed-currency/${currencyId}`,
            providesTags: ['currency']
        }),

        createCurrency: builder.mutation({
            query: (currencyDetails) => ({
                url: '/currency-management/managed-currency',
                method: 'POST',
                body: currencyDetails
            }),
            invalidatesTags: ['currency']
        }),

        updateCurrency: builder.mutation({
            query: (currencyDetails) => ({
                url: '/currency-management/managed-currency',
                method: 'PUT',
                body: currencyDetails
            }),
            invalidatesTags: ['currency']
        }),

        deleteCurrency: builder.mutation({
            query: (currencyId) => ({
                url: `/currency-management/managed-currency/${currencyId}`,
                method: 'POST',
            }),
            invalidatesTags: ['currency']
        }),
    })
});

// Export hooks for usage in functional components  
export const {
    useGetAllCurrenciesQuery,
    useGetCurrencyByIdQuery,
    useLazyGetCurrencyByIdQuery,
    useCreateCurrencyMutation,
    useUpdateCurrencyMutation,
    useDeleteCurrencyMutation,
} = currencyService;